import * as debug from 'debug';
import { fromNullable } from 'fp-ts/lib/Option';
import { __forceRefreshState, getRoot } from 'sdi/app';
import { makeIcon } from 'sdi/components/button';
import { nameToString } from 'sdi/components/button/names';
import { A, DIV } from 'sdi/components/elements';
import { buttonTooltipLeft } from 'sdi/components/tooltip';
import { iife } from 'sdi/lib';
import tr from 'sdi/locale';
import { getMapInfo, withoutProfileFancy } from '../queries/app';

const logger = debug('sdi:fullscreen');

const getFullScreenElement = iife(() => {
    let fullscreen: Element | null = null;

    document.addEventListener('fullscreenchange', () => {
        fullscreen = document.fullscreenElement;
        __forceRefreshState();
    });
    return () => fromNullable(fullscreen);
});

const fullscreenButtonOn = makeIcon('fullscreen', 2, 'expand', {
    position: 'bottom-right',
    text: () => tr.core('fullscreen'),
});
const fullscreenButtonOff = makeIcon('fullscreen', 2, 'compress', {
    position: 'bottom-right',
    text: () => tr.core('fullscreen-exit'),
});

const tryFullScreenOn = () =>
    fromNullable(document.querySelector('.app-inner')).map(innerElement =>
        innerElement
            .requestFullscreen()
            .then(() => logger('request fullscreen OK'))
            .catch(err => logger('request fullscreen error', err))
    );

const tryFullScreenOff = () =>
    document
        .exitFullscreen()
        .then(() => logger('exit fullscreen OK'))
        .catch(err => logger('exit fullscreen error', err));

const atlasButtonLink = () =>
    getMapInfo().fold(DIV({}), mapInfo =>
        buttonTooltipLeft(
            tr.embed('atlasLinkLabel'),
            {
                className: 'btn btn-2 atlas-link icon-only',
            },
            A(
                {
                    href: `${getRoot()}view/${mapInfo.id}`,
                    target: '_blank',
                    className: 'fa icon',
                },
                nameToString('external-link-alt')
            )
        )
    );

export const renderActions = () =>
    DIV(
        'map-actions',
        getFullScreenElement()
            .map(() => fullscreenButtonOff(tryFullScreenOff))
            .getOrElse(fullscreenButtonOn(tryFullScreenOn)),
        withoutProfileFancy(atlasButtonLink)
    );

export default renderActions;

logger('loaded');
